import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Fragment, useContext } from "react";
import { OverlayTrigger, Tooltip, Button } from "react-bootstrap";
import { BasicContext } from "../../App";
import { faEdit, faEye, faEyeSlash, faCheckCircle } from "@fortawesome/free-regular-svg-icons";
import { faCircleNotch, faCoins } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

const PassesListTable = (props) => {
    const { e } = props;
    const { t } = useTranslation();
    const { changeView } = useContext(BasicContext);

    return (
        <Fragment>
            <tr>
                <td className="bold border-bottom-0 pb-0">{e.pass_name}</td>
                <td className="text-end border-bottom-0 pb-0">
                    <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
                    {e.pass_duration_days} {e.pass_duration_days === 1 ? t("day") : t("days")}
                </td>
                <td
                    className="text-center"
                    rowSpan={
                        e.pass_quantity !== null && e.pass_user_limit !== null
                            ? 6
                            : e.pass_quantity !== null || e.pass_user_limit !== null
                            ? 5
                            : 4
                    }
                >
                    <OverlayTrigger
                        placement="top"
                        delay={{ show: 200, hide: 150 }}
                        overlay={<Tooltip id={`editPass${e.pass_id}`}>{t("passes.editPass")}</Tooltip>}
                    >
                        <Button
                            variant="outline-secondary"
                            className="btn-table-action"
                            onClick={() =>
                                changeView({ nav: "passes", sub: "editPass", params: { passID: e.pass_id } })
                            }
                        >
                            <FontAwesomeIcon icon={faEdit} />
                        </Button>
                    </OverlayTrigger>
                </td>
            </tr>
            <tr>
                <td className="border-bottom-0 pb-0">
                    {t("entrances")}: <span className="bold">{e.pass_entries}</span>
                </td>
                <td className="text-end border-bottom-0 pb-0">
                    <FontAwesomeIcon icon={faCircleNotch} className="me-2" />
                    {e.pass_active === "Y" ? t("active") : t("inactive")}
                </td>
            </tr>
            <tr>
                <td className="border-bottom-0 pb-0">
                    <FontAwesomeIcon icon={faCoins} className="me-2" />
                    {e.pass_price} {t("currency")}
                </td>
                <td className="text-end border-bottom-0 pb-0">
                    <FontAwesomeIcon icon={e.pass_visible === "Y" ? faEye : faEyeSlash} className="me-2" />
                    {e.pass_visible === "Y" ? t("visible") : t("invisible")}
                </td>
            </tr>

            {e.pass_quantity !== null && (
                <tr>
                    <td colSpan={2} className="border-bottom-0 pb-0">
                        {t("passes.passQuantity")}:<span className="bold"> {e.pass_quantity}</span>
                    </td>
                </tr>
            )}
            {e.pass_user_limit !== null && (
                <tr>
                    <td colSpan={2} className="border-bottom-0 pb-0">
                        {t("passes.passUserLimit")}:<span className="bold"> {e.pass_user_limit}</span>
                    </td>
                </tr>
            )}

            <tr>
                <td colSpan={2}>
                    {t("classes.classesTypes")}:{" "}
                    <span className="text-break">
                        {e.class_types.map((el, j) => (
                            <Fragment key={j}>
                                {el.class_type_name}
                                {j < e.class_types.length - 1 ? ", " : ""}
                            </Fragment>
                        ))}
                    </span>
                </td>
            </tr>
        </Fragment>
    );
};

export default PassesListTable;
